<template>
<div class="pk-imp-outer">
  <div class="pk-imp-container">
<p class="title">Impressum</p>

<p class="subtitle">Projektleitung</p>

<p>Prof. Dr. Martin Loiperdinger  <br/>
Medienwissenschaft, Screen 1900, Fachbereich II: Sprach-, Literatur- und Medienwissenschaften, Universität Trier
</p>

<p>Prof. Dr. Claudine Moulin <br/>
Trier Center for Digital Humanities, Universität Trier
</p>

<p class="subtitle">Projektkoordination</p>

<p>Dr. Ludwig Vogl-Bienek <br/>
Medienwissenschaft, Screen 1900
</p>

<p>Dr. Thomas Burch <br/>
Trier Center for Digital Humanities
</p>

<p>Dr. Vera Hildenbrandt <br/>
Trier Center for Digital Humanities
</p>

<p class="subtitle">Editorische Bearbeitung</p>

<p>Lydia Jakobs <br/>
Daniela Müller-Kolb <br/>
Medienwissenschaft, Screen 1900</p>


<p class="subtitle">Technische Umsetzung und grafische Gestaltung</p>
 
<p>Roland Dahm  <br/>
Yu Gan <br/>
Li Sheng <br/>
Trier Center for Digital Humanities
</p>

<p class="subtitle">Kontakt</p>

<p>Prof. Dr. Claudine Moulin <br/>
Wissenschaftliche Leitung <br/>
Trier Center for Digital Humanities <br/>
Universität Trier <br/>
Universitätsring 15 <br/>
D-54296 Trier <br/>
</p>
<p></p>
<p>elaterna@uni-trier.de <br/>
Tel.: 0049 (0) 651 201 3377 (Sekretariat des TCDH)
</p>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
export default Vue.extend({
  mounted() {
    if (this.$matomo) {
      this.$matomo.trackPageView('Impressum');
    }
  }
});
</script>


<style lang="scss" scoped>

.pk-imp-outer {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.pk-imp-container {
  width: 700px;
  padding-top: 50px;
  margin-left: calc((100vw - 700px) / 2);
  // font-family: 'Times New Roman', Times, serif;
  
  .title {
    font-weight: 700;
    font-size: 1.5em;
    color: #337ab7;
  }

  .subtitle {
    font-size: 1.2em;
    color: #337ab7;
  }
}
</style>